<template>
	<div id="scanInput" :class="{ 'shown' : show}">
		<input type="text" v-model="scan" ref="scannerInput" @change="checkEan" />
	</div>
</template>

<style lang="scss">
#scanInput {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  overflow:hidden;
  &.shown{
	  height: auto;
	  width: auto;
	  opacity: 1;
  }
}
</style>

<script>
export default {
	name: 'scanInput',
	methods:{
		checkEan(){
			if(this.scan.length > 0){
				this.$emit('scan', this.scan)
			}
			this.scan = ''
		},
		scanDebug(){
			this.scan = this.debugEan
			this.checkEan()
		}
	},
	destroyed(){
		document.onkeydown = null
	},
	async mounted(){
		let input = await this.$refs.scannerInput
		let $this = this
		document.onkeydown = function(e){
			if(e.key === 'Insert'){
				$this.show = !$this.show
			}
			// This check is necessary to keep the focus on another input than the scanner while typing
			if(document.activeElement.nodeName !== 'INPUT'){
				input.focus()
			}
		}
	},
	data(){
		return{
			scan: [],
			debugEan: '',
			show: false
		}
	}
}
</script>
